import { CampaignCode } from '@/types';

export const CAMPAIGN_TYPE_LABELS: Record<CampaignCode['campaignType'], string> = {
  free_1year: 'Standardプラン 1年無料',
  free_6months: 'Standardプラン 半年無料',
  free_3months: 'Standardプラン 3ヵ月無料',
  free_1month: 'Standardプラン 1か月無料',
  discount_50: '永年 50% OFF',
  fixed_price: '永年固定金額',
};

export const getCampaignTypeLabel = (type: CampaignCode['campaignType']): string => {
  return CAMPAIGN_TYPE_LABELS[type] || type;
};

export const getCampaignDescription = (campaign: CampaignCode): string => {
  switch (campaign.campaignType) {
    case 'free_1year':
      return 'Standardプラン1年間無料でご利用いただけます';
    case 'free_6months':
      return 'Standardプラン半年間無料でご利用いただけます';
    case 'free_3months':
      return 'Standardプラン3ヵ月間無料でご利用いただけます';
    case 'free_1month':
      return 'Standardプラン1ヵ月間無料でご利用いただけます';
    case 'discount_50':
      return 'Standardプラン料金が永年50%OFFでご利用いただけます';
    case 'fixed_price':
      return campaign.discountAmount
        ? `Standardプラン料金が永年¥${campaign.discountAmount.toLocaleString()}/月でご利用いただけます`
        : 'Standardプラン料金が永年固定金額でご利用いただけます';
    default:
      return '';
  }
};

export const isCampaignValid = (campaign: CampaignCode): boolean => {
  if (campaign.status !== 'active') {
    return false;
  }

  const now = new Date();

  // 有効期間開始前
  if (campaign.validFrom && campaign.validFrom.toDate() > now) {
    return false;
  }

  // 有効期間終了後
  if (campaign.validUntil && campaign.validUntil.toDate() < now) {
    return false;
  }

  // 利用回数上限
  if (campaign.maxUses !== undefined && campaign.currentUses >= campaign.maxUses) {
    return false;
  }

  return true;
};
